export const ACTIVE = 'ACTIVE';
export const DEACTIVATED = 'DEACTIVATED';
export const REMOVED = 'REMOVED';